import { useDatabase } from "./DatabaseContext";
import { useMainAccessors } from "./useMainAccessors";

const ANALYTICS_COLLECTION = "analytics";
const ANALYTICS_PATH = [ANALYTICS_COLLECTION];

export const useAnalyticsAccessors = () => {
  const db = useDatabase();
  return useMainAccessors(db, ANALYTICS_PATH);
};
